import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { HTMLAttributes } from "react";

type Props = HTMLAttributes<HTMLDivElement> & {
  isVisible: boolean;
  onClose: () => void;
  title: string;
  // Optional testid forwarded to the close button so callers re-skinning a
  // legacy dialog can preserve their existing E2E selector.
  closeButtonTestId?: string;
  // Optional testid forwarded to the dialog Paper (the element that carries
  // role="dialog"). Needed because `[role="dialog"]` is not unique on pages
  // that mount other dialogs (e.g. the per-card Power BI modal on /datasets),
  // so E2E specs need a stable root to scope field locators to.
  dialogTestId?: string;
};

export function ModalBase({
  children,
  isVisible,
  onClose,
  title,
  closeButtonTestId,
  dialogTestId,
}: Props) {
  return (
    <Dialog
      open={isVisible}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={dialogTestId ? { "data-testid": dialogTestId } : undefined}
    >
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>{title}</Grid>
          <Grid item>
            <IconButton onClick={onClose} data-testid={closeButtonTestId}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}
